import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Headroom from 'react-headroom';
import scrollParent from '../../services/scroll-parent';
import { connect } from 'react-redux';
import { updateHeader } from '../../actions/update-header';

export class WrapperHeadroom extends Component {
  static propTypes = {
    updateHeader: PropTypes.func,
    children: PropTypes.node,
    isAuthenticated: PropTypes.bool,
    menu: PropTypes.node,
  };

  constructor(props) {
    super(props);

    this.handlePin = this.handlePin.bind(this);
    this.handleUnpin = this.handleUnpin.bind(this);
    this.handleHeaderHeightChange = this.handleHeaderHeightChange.bind(this);
    this.setHeadroom = this.setHeadroom.bind(this);
  }

  componentWillReceiveProps({ isAuthenticated }) {
    if (!this.props.isAuthenticated && isAuthenticated) {
      this.headroom.pin();
    }
  }

  componentDidMount() {
    this.props.updateHeader({
      offset: 0,
      height: this.getHeight(),
    });
  }

  componentWillUnmount() {
    this.props.updateHeader({
      offset: 0,
      height: 0,
    });
  }
  handleHeaderHeightChange() {}

  handlePin() {
    this.props.updateHeader({
      offset: 0,
      height: this.getHeight(),
    });
  }

  handleUnpin() {
    this.props.updateHeader({
      offset: this.getOffset() || 0,
      height: this.getHeight(),
    });
  }

  getOffset() {
    return this.props.menu ? -50 : undefined;
  }

  getHeight() {
    return this.props.menu ? 100 : 50;
  }

  setHeadroom(element) {
    this.headroom = element;
  }

  render() {
    const pinStart = this.getHeight() - 20;
    const { children } = this.props;
    const params = {
      pinStart,
      disableInlineStyles: true,
      onPin: this.handlePin,
      onUnpin: this.handleUnpin,
      parent: () => scrollParent(),
      style: { height: 0 },
    };

    return (
      <Headroom ref={this.setHeadroom} {...params}>
        {children}
      </Headroom>
    );
  }
}

const mapDispatchToProps = {
  updateHeader,
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});
export default connect(mapStateToProps, mapDispatchToProps)(WrapperHeadroom);



// WEBPACK FOOTER //
// ./app/components/wrapper-headroom/wrapper-headroom.js